export const getScrollBottom = function () {
  // 获取滚动的组件
  const eleMessageList = document.querySelector('.page-scroll-container');
  if (eleMessageList) {
    return eleMessageList.scrollHeight - eleMessageList.scrollTop - eleMessageList.clientHeight;
  }
  return 0;
};

export const scrollLimit = 300; // 把这个值设置大一些，否则滚动总是有问题。。
